module.exports = __webpack_public_path__ + "img/both.7d82a106.png";